import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './styles/globals.css';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Tools from './pages/Tools';
import Pricing from './pages/Pricing';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Signup from './pages/Signup';
import MyStack from './pages/MyStack';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <div className="bg-orbs" aria-hidden />
        <Navbar />
        <Routes>
          <Route path="/"           element={<Home />} />
          <Route path="/tools"      element={<Tools />} />
          <Route path="/pricing"    element={<Pricing />} />
          <Route path="/blog"       element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/signup"     element={<Signup />} />
          <Route path="/stack"      element={<MyStack />} />
        </Routes>
        <Footer />
      </Router>
    </AuthProvider>
  );
}
